module.exports = __webpack_public_path__ + "media/promo/courses/images/varsbg-21178627914a6e3b8a575e00fa7673d9.jpg";